import { CREATE_PAYMENT, GET_PAYMENT, SET_ALL_PAYMENTS, SET_ALL_PAYMENTS_SELECT, UPDATE_PAYMENT } from "../../reducerTypes"

const initialState = {
  getData: {},
  getList: [],
  selectData: [],
}

const tagReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_PAYMENTS:
      return {
        ...state,
        getList: action.payload
      }
    case CREATE_PAYMENT:
      return {
        ...state,
        getData: action.payload
      }
    case GET_PAYMENT:
      return {
        ...state,
        getData: action.payload
      }
    case UPDATE_PAYMENT:
      return {
        ...state,
        getData: action.payload
      }
    case SET_ALL_PAYMENTS_SELECT:
      const contentData = action.payload ? action.payload : [];
      const selectData = [];
      contentData.map((data) => {
        selectData.push({
          value: data.id,
          label: `${data.name}`
        })
        return data
      });
      return {
        ...state,
        selectData: selectData
      }
    default:
      return state
  }
}

export default tagReducer
